<div
  class="shrink-0 flex select-none items-center justify-center gap-1 border-t border-slate-200 bg-slate-50 py-2 text-center text-[10px]"
>
  <span class="font-bold text-primary">© {{ currentYear }} Contreras</span>
  <span class="text-slate-300">·</span>
  <span class="text-slate-500">
    Desarrollado por <span class="font-bold text-primary">Blister</span>
  </span>
</div>
